<div class="modal fade " id="header_create_newpopup1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <!-- <button type="button" class="close" data-dismiss="modal">&times;</button> -->
        <h4 class="modal-title" id="sim_popup_header">
          <span>Please wait for the execution to complete.</span>
        </h4>
        <!-- <button type="button" class="close" data-dismiss="modal">&times;</button> -->
      </div>
      <div class="modal-body">
        <div id='sim_progress_div' class="sim_prog"></div>
        <div id='what_if_progress_div'></div>
    </div>
  </div>
</div>
</div>
<div class="modal fade " id="header_create_newpopup2" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <!-- <button type="button" class="close" data-dismiss="modal">&times;</button> -->
        <h4 class="modal-title">
          <span>Please wait for the execution to complete.</span>
        </h4>
        <!-- <button type="button" class="close" data-dismiss="modal">&times;</button> -->
      </div>
      <div class="modal-body">
        <div id='sim_progress_div1'></div>
    </div>
  </div>
</div>
</div>
